export class SortField {
    field;
    sort;

    constructor(name, asc) {
        this.field = name;
        this.sort = asc;
    }
}

export class UserSortField {
    static registrationDate = new SortField("registrationDate", "desc");
    static firstName = new SortField("name", "asc");
    static lastName = new SortField("lastName", "asc");
    static email = new SortField("email", "asc");
}